// TODO: This code should use @dextall/2d-editors-colors package when
// https://dextall.atlassian.net/browse/PS-120 is resolved, e.g. when
// we have a common colors format and factory and it's clear about
// the dependencies of the package.

import { DEFAULT_BORDER_COLOR } from "./louvreGrillMaterialDesignDefinition";

export const getLouvreBorderColor = (color: THREE.Color): THREE.Vector4 => {
    const ratio = getContrastRatio(DEFAULT_BORDER_COLOR, color);
    if (ratio >= MIN_CONTRAST_RATIO) {
        return DEFAULT_BORDER_COLOR;
    }

    const invertedColor = getInvertedColor(DEFAULT_BORDER_COLOR.x, DEFAULT_BORDER_COLOR.y, DEFAULT_BORDER_COLOR.z);

    return darken(invertedColor, DARKENING_FACTOR);
};

const MIN_CONTRAST_RATIO = 1.5;
const DARKENING_FACTOR = 0.7;

const getContrastRatio = (borderColor: THREE.Vector4, louvreColor: THREE.Color): number => {
    const luminanceA = getRelativeLuminance(borderColor.x, borderColor.y, borderColor.z);
    const luminanceB = getRelativeLuminance(louvreColor.r, louvreColor.g, louvreColor.b);

    const L1 = Math.max(luminanceA, luminanceB);
    const L2 = Math.min(luminanceA, luminanceB);

    return (L1 + 0.05) / (L2 + 0.05);
};

const getInvertedColor = (red: number, green: number, blue: number): THREE.Vector4 => {
    return new THREE.Vector4(1.0 - red, 1.0 - green, 1.0 - blue, 1.0);
};

const darken = (color: THREE.Vector4, factor: number): THREE.Vector4 => {
    const k = clamp(factor, 0, 1);

    return new THREE.Vector4(color.x * k, color.y * k, color.z * k, color.w);
};

const getRelativeLuminance = (red: number, green: number, blue: number): number => {
    // Standard luminance weighting
    return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
};

const clamp = (value: number, min: number, max: number): number => {
    if (!Number.isFinite(value)) {
        return min;
    }
    if (min > max) {
        // Guard: if someone passes wrong bounds, do not swap to avoid hiding bugs
        return value;
    }
    return Math.max(min, Math.min(max, value));
};
